/**
 * Formata data para exibição em pt-BR (dd/mm/yyyy).
 * Para strings YYYY-MM-DD ou ISO, usa apenas a parte da data para evitar
 * subtração de 1 dia por timezone (ex.: "2025-02-25" em UTC vira 24/02 no Brasil).
 */
export function formatarDataPtBr(valor?: string | Date | null): string {
  if (valor == null) return '';
  if (valor instanceof Date) {
    const dia = String(valor.getDate()).padStart(2, '0');
    const mes = String(valor.getMonth() + 1).padStart(2, '0');
    const ano = valor.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }
  const str = String(valor).trim().substring(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
    const [ano, mes, dia] = str.split('-');
    return `${dia}/${mes}/${ano}`;
  }
  const d = new Date(valor);
  if (!isNaN(d.getTime())) return d.toLocaleDateString('pt-BR');
  return str;
}
